// import '../css/ai_helper.less';
import ServiceClass from './main/ServiceClass.js';
// import HtmlDom from './main/HtmlDom.js';
import makePost from './main/makePost.js';
import './main/helpers.js';

import AI_helperGroupClass from './classes/ai_helperGroupClass.js';
import AI_helperItemClass from './classes/ai_helperItemClass.js';
import AI_helperComplectClass from './classes/ai_helperComplectClass.js';
import AI_helperCommonClass from './classes/ai_helperCommonClass.js';
import AI_helperPrivilegeClass from './classes/ai_helperPrivilegeClass.js';

window.AI_helperGroupClass = AI_helperGroupClass;
window.AI_helperItemClass = AI_helperItemClass;
window.AI_helperComplectClass = AI_helperComplectClass;
window.AI_helperCommonClass = AI_helperCommonClass;
window.AI_helperPrivilegeClass = AI_helperPrivilegeClass;
// window.HtmlDom = HtmlDom;

// import mainTemplate from './templates/main.html';
// import fixed_blockTemplate from './templates/fixed_block.html';
// import infoHandleTemplate from './templates/infoHandle.html';
// import infoBubbleTemplate from './templates/infoBubble.html';
// import rulesBubbleTemplate from './templates/rulesBubble.html';
// import menuComplectsBubbleTemplate from './templates/menuComplectsBubble.html';
// import menuComplectsItemTemplate from './templates/menuComplectsItem.html';
// import menuComplectsItemNoCompectTemplate from './templates/menuComplectsItemNoComplect.html';
// import previewTemplate from './templates/preview.html';
// import previewHeaderTemplate from './templates/previewHeader.html';
// import proccessTemplate from './templates/proccessOrder.html';
// import initButtonTemplate from './templates/initButton.html';
// import leftTemplate from './templates/left.html';

// const env = process.env.NODE_ENV || 'production';

const ai_helper = {
    params: {
        url: 'https://sale.katris.ru/proxy/auth/',
        key: 'W5pRNSx8Dx3tGY65xx3BOgAAAAE',
        session: null,
        init_data: null,
        storage_name: 'AI_HELPER_45745673029734',
        account: null,
        container: 'AI_helper_app',
        H: null,
    },

    user: {
        uid: 0,
        cid: 0,
        sale: 0,
        sum: 0,
        sale_limits: {
            main: [],
            full: [],
        },
    },

    storage_id: 'AI_HELPER_457456730',
    stored: null,
    id: Math.floor(Math.random() * (9999 - 1000)) + 1000,
    parent_id: 'right___',
    folderURL: 'ai_helper',
    cat: [8394, 8435, 9451, 8452, 8451, 30003801, 10069, 30003573, 30004610, 10070, 10072, 30004618, 30003591],
    payers: null,
    deliveries: null,
    deliveryTypes: {
        0: "Самовывоз",
        // 1: "На выбор КАТРИС",
        1: "Доставка по Москве",
        11: "Байкал сервис",
        14: "Деловые линии",
        // 16: "Желдорэкспедиция",
        // 17: "Империя Авто",
        // 18: "МАКТЭКБАЙКАЛ",
        // 19: "ПЭК",
        //20:"РАТЕК",
        //  28: "Стейл",
        // 36: "Тк КИТ"
    },

    loaded: false,
    debug: false,
    service_debug: false,
    inputTimer: null,
    inputTimeout: 300,
    cname: '',
    profile: null,
    fixed_block: null,
    infoHandle: null,
    infoBubble: null,
    rulesBubble: null,
    menuComplectsBubble: null,
    previewBubble: null,
    proccessBubble: null,
    table_goods: null,
    dom_main: null,
    dom_basket: null,
    infoFields: {},
    payer: 0,
    delivery: 0,
    num: '',
    ccount: 0,
    addButton: null,
    complects: [],
    mainContainer: null,
    containers: {
        header: null,
        items: null,
        total: null,
    },
    fullsum: 0,
    fullsumbasket: 0,
    // previewsum: 0,
    salesum: 0,
    salesumPreview: 0,
    cashbackSum: 0,
    cashbackSumPreview: 0,
    saletotalsum: 0,
    saletotalsumPreview: 0,
    order: [],
    orderItems: {},

    ids: [],
    sale: 0,
    wholeSum: 0,
    privilegeBubble: null,
    sale_exceptions: [],
    sale_exceptions_cashback: [],
    exceptions: [],
    menu_complects: [],
    discount_pics_ids: [],
    crutch: [],

    ServiceClass: ServiceClass,
    makePost: makePost,

    number_format: window.number_format,

    additionalDiscount: [],
    commonTree: [],

    boxAction: [],

    init: function (params = null, cb) {
        if (params) {
            for (let key in params) {
                if (Object.prototype.hasOwnProperty.call(params, key))
                    this.params[key] = params[key];
            }
        }
        let r = document.getElementById(this.parent_id);
        if (r) {
            let cls = r.getAttribute('class');
            r.setAttribute('class', cls + ' ' + this.params.container);
            // this.containers.handle = document.createElement('div');
            // this.containers.rules = document.createElement('div');
            // this.containers.rules.setAttribute('class', 'ai_helper_handles');
            // this.containers.handle.setAttribute('class', 'ai_helper_handles');
            this.create_ai_handle(this.containers.handle);
            // this.folderRules();
            // r.innerHTML = '';
            // r.appendChild(this.containers.handle);
            // r.appendChild(this.containers.rules);
        }
        // this.createLeftMenu();
        this.initMain(function () {
            if (cb) cb();
        });
    },
    folderRules: function () {
        // let container = this.containers.rules;
        this.makePost('aiHelper', 'rules', {}, null, function (respond) {
            if (respond.status === 'OK')
                // container.innerHTML=respond.data;
                console.log('OK')
        });
    },
    create_ai_handle: function () {
        // this.dom_button = new HtmlDom(initButtonTemplate, {}, this);
        // if (container) container.appendChild(this.dom_button);
    },
    createLeftMenu: function () {
        // let l = document.getElementById('left');
        // if (l) {
        //     l.innerHTML='';
        //     let cls = l.getAttribute('class');
        //     l.setAttribute('class',cls + ' ' + this.params.container);
        //     this.dom_leftMenu = new HtmlDom(leftTemplate, {}, this);
        //     //let button = this.dom_leftMenu.querySelectorAll('[controls="initButton"]')[0];
        //     l.appendChild(this.dom_leftMenu);
        // }
    },
    initMain: function (cb) {
        if (window.localStorage) {
            this.stored = window.localStorage.getItem(this.storage_id);
            this.mainContainer = document.getElementById(this.params.container);
            if (!this.mainContainer) {
                // this.mainContainer = document.createElement('div');
                // this.mainContainer.id = this.params.container;
                // this.mainContainer.setAttribute('class',this.params.container);
                // document.body.appendChild(this.mainContainer);
            }
            // this.createFixedBlock();
            // this.createInfoHandle();
            // this.createInfoBubble();
            // this.createRulesBubble();
            // this.createMenuComplectsBubble();
            // this.createPreviewBubble();
            // this.createProccessBubble();
            // let model = {};
            // this.dom_main = new HtmlDom(mainTemplate, model, this);
            // this.containers.items = this.dom_main.querySelectorAll('[containers="items"]')[0];
            // this.containers.total = this.dom_main.querySelectorAll('[containers="total"]')[0];

            // this.infoFields.total = {};
            // this.infoFields.total.total = this.dom_main.querySelectorAll('[model="total"]')[0];
            // this.infoFields.total.sum = this.dom_main.querySelectorAll('[model="sum"]')[0];
            // this.infoFields.total.sale_sum = this.dom_main.querySelectorAll('[model="sale_sum"]')[0];
            // this.mainContainer.appendChild(this.dom_main);
            // this.mainContainer.appendChild(this.fixed_block);
            // this.mainContainer.appendChild(this.infoHandle);
            // this.mainContainer.appendChild(this.infoBubble);
            // this.mainContainer.appendChild(this.rulesBubble);
            // this.mainContainer.appendChild(this.menuComplectsBubble);
            // this.mainContainer.appendChild(this.previewBubble);
            // this.mainContainer.appendChild(this.proccessBubble);
            let data = {id: 0, count: 0, square: 0};
            let self = this;

            // self.makePost('aiHelper', 'get_common_cat', {}, null, function(respond) {
            //     if (respond.status === 'OK') {
            //         for (let key in respond.data) {
            //             respond.data[key].expanded = false;
            //         }
            //
            //         let sortFunction = function(a, b) {
            //             let aname = a.name.toLowerCase();
            //             let bname = b.name.toLowerCase();
            //             if (aname < bname) return -1;
            //             if (aname > bname) return 1;
            //         };
            //
            //         let items1 = Object.keys(respond.data).map(function(key) {return respond.data[key];});
            //         items1.sort(sortFunction);
            //         for (let k1 in items1) {
            //             items1[k1].items = Object.keys(items1[k1].items).map(function(key) {return items1[k1].items[key];});
            //             items1[k1].items.sort(sortFunction);
            //             for (let k2 in items1[k1].items) {
            //                 items1[k1].items[k2].items = Object.keys(items1[k1].items[k2].items).map(function(key) {return items1[k1].items[k2].items[key];});
            //                 items1[k1].items[k2].items.sort(sortFunction);
            //             }
            //         }
            //
            //         self.commonTree = items1;
            //
            //         console.log('ct', self.commonTree)
            //     } else {
            //         console.log('ERROR: ');
            //         console.log(respond);
            //
            //     }
            // });

            // ai_helper.makePost('katrisService', 'getBoxAction', {}, null, function (response) {
            //     if (response.status === 'OK') {
            //         self.boxAction = [];
            //         for (let item in response.data) {
            //             self.boxAction.push(parseInt(response.data[item].goodID))
            //         }
            //     }
            // });

            self.makePost('katrisService', 'getAdditionalDiscount', {}, null, function (respond) {
                if (respond.status === 'OK') {
                    // console.log(respond)
                    self.additionalDiscount = respond.data.discounts;

                    // console.log(self.additionalDiscount)
                } else {
                    console.log('ERROR: ');
                    console.log(respond);

                }
            });

            this.makePost('aiHelper', 'init_info', data, null, function (respond) {
                if (respond.status === 'OK') {
                    respond = respond.data;
                    self.respond = respond;

                    if (respond.user) {
                        self.user = respond.user;
                        self.sale = self.user.sale;
                        self.wholeSum = self.user.sum;
                        if (respond.debug)
                            self.debug = respond.debug;
                        if (respond.service_debug)
                            self.service_debug = respond.service_debug;
                    }
                    //console.log(self.service_debug);
                    if (respond.sale_exceptions) self.sale_exceptions = respond.sale_exceptions;
                    if (respond.sale_exceptions_cashback) self.sale_exceptions_cashback = respond.sale_exceptions_cashback;
                    if (respond.exceptions) self.exceptions = respond.exceptions;
                    if (respond.complects) self.menu_complects = respond.complects;
                    if (respond.discount_pics_ids) self.discount_pics_ids = respond.discount_pics_ids;
                    if (respond.crutch) self.crutch = respond.crutch;
                    // console.log(respond.sale_exceptions)
                    // console.log(self.crutch)
                    //	console.log('self.discount_pics_ids',self.discount_pics_ids);
                    // console.log('STORED', self.stored);
                    // if (self.stored != null) self.restoreComplects();
                    // else {
                    //     self.showMenuComplectsBubble();
                    //     self.render();
                    // }

                    if (cb) cb();
                } else {
                    console.log('ERROR: ');
                    console.log(respond);
                    if (cb) cb();
                }
            });


        } else alert('Ваш браузер не поддерживает хранение данных! Проверьте настройки браузера, переустановите браузер или используйте другой браузер!');
    },
    renderFields: function (model, value) {
        for (let key in this.infoFields) {
            if (Object.prototype.hasOwnProperty.call(this.infoFields, key)) {
                let block = this.infoFields[key];
                if (block[model]) {
                    if (typeof value === 'string') {
                        block[model].innerHTML = value;
                    } else {
                        block[model].innerHTML = window.number_format(value, 2, '.', ' ');
                    }
                }
            }
        }
    },
    minimize_complects: function () {
        for (let key in this.complects) {
            if (Object.prototype.hasOwnProperty.call(this.complects, key)) {
                if (this.complects[key]) {
                    this.complects[key].minimize();
                }
            }
        }
    },
    updateComplectsInfo: function () {
//         // this.fixed_block.style.display='none';
//         // let html = '';
//         for (let key in this.complects) {
//             if (Object.prototype.hasOwnProperty.call(this.complects, key)) {
//                 if (this.complects[key] && this.complects[key].infoFields) {
//                     if (!this.complects[key].minimized && this.complects[key].infoFields.total) {
//                         if (this.complects[key].infoFields.total.next_sale) {
//                             html += this.complects[key].infoFields.total.next_sale.innerHTML;
//                         }
//                         if (this.complects[key].infoFields.total.next_sum && this.complects[key].infoFields.total.next_sum.innerHTML!=='') {
//                             html += ' : <b style="color:red;">'+this.complects[key].infoFields.total.next_sum.innerHTML+'</b>';
//                         }
//                         break;
//                     }
//                 }
//             }
//         }
//         if (html !== '') {
//             this.fixed_block.style.display = 'block';
//             this.fixed_block.innerHTML = html;
//         }
// //console.log(html);
    },
    exit: function () {
        if (confirm("Вы точно хотите выйти из Интеллектуального расчета?")) this.destroy();
    },
    destroy: function () {
        if (this.mainContainer) {
            this.mainContainer.parentNode.removeChild(this.mainContainer);
            this.mainContainer = null;
        }
        this.complects = [];
        this.ids = [];
        window.location.reload();
    },
    getFullSum: function (cb) {
        let self = this;
        self.fullsum = 0;
        self.fullsumPreview = 0;
        // self.previewsum = 0;
        for (let k in self.complects) {
            if (Object.prototype.hasOwnProperty.call(self.complects, k)) {
                let complect = self.complects[k];
                if (complect) {
                    let basket_sum = complect.get_basket_sum();
                    // self.fullsum += basket_sum;
                    if (complect.inBusket) {
                        self.fullsum += basket_sum;
                    } else {
                        self.fullsumPreview += basket_sum;
                    }
                }
            }
        }
        // if (self.fullsum == 0 && self.previewsum != 0) self.fullsum = self.previewsum;
        if (cb) cb({fullsum: self.fullsum, fullsumPreview: self.fullsumPreview});
    },
    check_complect: function () {
        let self = this;
        this.getFullSum(function (fs) {
            for (let k in self.complects) {
                if (Object.prototype.hasOwnProperty.call(self.complects, k)) {
                    let complect = self.complects[k];
                    if (complect) {
                        complect.check_complect_exe(fs);
                    }
                }
            }
            self.salesum = 0;
            self.cashbackSum = 0;
            self.saletotalsum = 0;

            self.salesumPreview = 0;
            self.cashbackSumPreview = 0;
            self.saletotalsumPreview = 0;

            // let sales = '';
            // if (self.containers.total) self.containers.total.innerHTML='';

            for (let k in self.complects) {
                if (Object.prototype.hasOwnProperty.call(self.complects, k)) {

                    let complect = self.complects[k];
                    // console.log(complect)
                    if (complect) {
                        // sales += '<tr><td>' + complect.hh + ' ' + complect.hh_add + '</td><td><div class="ihelper_total-red">' + complect.sale + '%</div></td></tr>';

                        if (complect.inBusket) {
                            self.salesum += complect.salesum;
                            self.cashbackSum += complect.cashbackSum;
                            self.saletotalsum += complect.saletotalsum;
                        } else {
                            self.salesumPreviw += complect.salesum;
                            self.cashbackSumPreview += complect.cashbackSum;
                            self.saletotalsumPreview += complect.saletotalsum;
                        }
                    }
                }
            }

            // console.log('check_c', self.salesum, self.cashbackSum, self.saletotalsum, self.salesumPreview , self.cashbackSumPreview , self.saletotalsumPreview);

            // if (self.containers.total) self.containers.total.innerHTML=sales;

            // self.renderFields('sum',self.fullsum);
            // self.renderFields('sale',self.sale);
            // self.renderFields('sale_sum',self.salesum);
            // self.renderFields('total',self.saletotalsum);
            // self.renderFields('prev_ballance',self.user.sum);
            if (self.inputTimer != null) clearTimeout(self.inputTimer);
            self.inputTimer = setTimeout(function () {
                self.storeComplects();
            }, self.inputTimeout);
        });
        this.updateComplectsInfo();
    },
    createMenuComplectsBubble: function () {
        // this.menuComplectsBubble = new HtmlDom(menuComplectsBubbleTemplate, {}, this);
        // this.menuComplectsBubble.style.display='none';
        // this.containers.menuComplects = this.menuComplectsBubble.querySelectorAll('[containers="menuComplects"]')[0];
    },
    add_complect: function (o) {
        //console.log('IDGOOD', o.id_good);
        // this.minimize();
        if (!o.id) o.id = 0;
        let index = this.complects.length;
        let complect = null;
        if (o.id > 0)
            complect = new AI_helperComplectClass(o, index, this);
        else {
            complect = new AI_helperCommonClass(o, index, this);
            complect.date = new Date();
        }
        if (complect) this.complects[index] = complect;
        this.render();
    },
    storeComplects: function () {
        let self = this;
        let arr = [];

        for (let k in this.complects) {
            if (Object.prototype.hasOwnProperty.call(this.complects, k)) {
                let complect = this.complects[k];
                if (complect)
                    arr[k] = complect.release();
            }
        }

        if (arr.length > 0)
            self.stored = JSON.stringify(arr);
        else
            self.stored = null;
        if (self.stored != null)
            window.localStorage.setItem(self.storage_id, self.stored);
        else
            window.localStorage.removeItem(self.storage_id);
    },
    restoreComplects: function () {
        let self = this;
        let arr = JSON.parse(this.stored);
        for (let index in arr) {
            if (Object.prototype.hasOwnProperty.call(arr, index)) {
                let o = arr[index];
                if (o) {
                    // console.log('o', o);
                    if (o.id > 0)
                        self.complects[index] = new AI_helperComplectClass(o, index, self);
                    else
                        self.complects[index] = new AI_helperCommonClass(o, index, self);
                    // self.complects[index].minimize();
                }
            }
        }
        this.check_complect();
        this.render();
    },
    render: function () {
        let self = this;
        // self.containers.items.innerHTML = '';
        self.ids = [];
        self.ccount = 0;
        for (let k in this.complects) {
            if (Object.prototype.hasOwnProperty.call(this.complects, k)) {
                let complect = this.complects[k];
                if (complect) {
                    self.ids.push(complect.id);
                    self.ccount++;
                }
            }
        }
        if (self.ccount > 0) {
            for (let k in this.complects) {
                if (Object.prototype.hasOwnProperty.call(this.complects, k)) {
                    // let complect = this.complects[k];
                    // if (complect)
                    //     self.containers.items.appendChild(complect.dom);
                }
            }
        } else {
            // self.containers.items.innerHTML = 'ПУСТО';
            // self.showMenuComplectsBubble();
            //this.folderRules();
        }
    },
    minimize: function () {
        // for (let k in this.complects) {
        //     if (Object.prototype.hasOwnProperty.call(this.complects, k)) {
        //         let complect = this.complects[k];
        //         if (complect) complect.minimize();
        //     }
        // }
    },
    repeat_order: function () {
        this.makePost('aiHelper', 'repeat_order', {}, null, function (respond) {
            if (respond.status === 'OK') {
                window.location = '/bin.php';
            }
        });
    },

    createFixedBlock: function () {
        // this.fixed_block = new HtmlDom(fixed_blockTemplate, {}, this);
        // this.infoFields.fixed={};
        // this.infoFields.fixed.sale_sum = this.fixed_block.querySelectorAll('[model="sale_sum"]')[0];
        // return this.fixed_block;
    },
    createInfoBubble: function () {
        // this.infoBubble = new HtmlDom(infoBubbleTemplate, {}, this);
        // this.infoBubble.style.display = 'none';
        // this.infoFields.info = {};
        // this.infoFields.info.prev_ballance = this.infoBubble.querySelectorAll('[model="prev_ballance"]')[0];
        // this.infoFields.info.sum = this.infoBubble.querySelectorAll('[model="sum"]')[0];
        // this.infoFields.info.sale = this.infoBubble.querySelectorAll('[model="sale"]')[0];
        // this.infoFields.info.sale_sum = this.infoBubble.querySelectorAll('[model="sale_sum"]')[0];
        // this.infoFields.info.total = this.infoBubble.querySelectorAll('[model="total"]')[0];
        // this.infoFields.info.next_sale = this.infoBubble.querySelectorAll('[model="next_sale"]')[0];
        // this.infoFields.info.next_sum = this.infoBubble.querySelectorAll('[model="next_sum"]')[0];
    },


    initMenuComplectsBubble: function () {

//menuComplectsItemTemplate
        let self = this;
        if (this.containers.menuComplects) {
            // this.containers.menuComplects.innerHTML='';
            // for (let k in self.menu_complects) {
            //     if (self.menu_complects.hasOwnProperty(k)) {
            //         let item = self.menu_complects[k];
            //         if (!in_array(item.id, self.ids)) {
            //             if (!item.alt_folder) item.alt_folder = '';
            //             let model = {
            //                 class: 'item',
            //                 id: item.id,
            //                 folder: item.folder,
            //                 alt_folder: item.alt_folder,
            //                 cls:'',
            //             };
            //             //console.log(item);
            //             if (self.sale_exceptions_cashback) {
            //                 if (self.crutch) {
            //                     model.cls = 'ihelper_menu_no_cashBack';
            //                     for (let k in self.crutch) {
            //                         if (self.crutch.hasOwnProperty(k)) {
            //                             if (typeof self.crutch[k][item.id_good] !== "undefined") {
            //                                 if (self.crutch[k][item.id_good] === item.parm1) {
            //                                     model.cls = 'ihelper_menu_cashBack';
            //                                 }
            //                             }
            //                         }
            //                     }
            //                     //console.log(self.crutch[item.id_good], item.parm1);
            //                 }
            //             }
            //             let idom = new HtmlDom(menuComplectsItemTemplate, model, this);
            //             idom.onclick = function () {
            //                 item.name = item.alt_folder;
            //                 item.id_good = parseInt(item.id_good);
            //                 self.add_complect(item);
            //                 self.hideMenuComplectsBubble();
            //             };
            //             this.containers.menuComplects.appendChild(idom);
            //         }
            //     }
            // }
            /**/
            if (!window.in_array("0", self.ids)) {
                // let idom = new HtmlDom(menuComplectsItemNoCompectTemplate, {}, this);
                // idom.onclick = function () {
                //     let item = this;
                //     let o = {
                //         id: item.getAttribute('ihelper_complect-id'),
                //         folder: item.getAttribute('ihelper_complect-folder'),
                //         name: item.getAttribute('ihelper_complect-name'),
                //         id_good: 0,
                //     };
                //     self.add_complect(o);
                //     self.hideMenuComplectsBubble();
                // };
                //
                // this.containers.menuComplects.appendChild(idom);
            }
        }
    },

    showMenuComplectsBubble: function () {
        this.hideProccessBubble();
        if (this.menuComplectsBubble) {
            this.initMenuComplectsBubble();
            this.menuComplectsBubble.style.display = 'block';
        }
    },

    hideMenuComplectsBubble: function () {
        if (this.menuComplectsBubble) this.menuComplectsBubble.style.display = 'none';
    },

    showInfoBubble: function () {
        if (this.infoBubble) this.infoBubble.style.display = 'block';
    },

    hideInfoBubble: function () {
        if (this.infoBubble) this.infoBubble.style.display = 'none';
    },

    showRulesBubble: function () {
        if (this.rulesBubble) this.rulesBubble.style.display = 'block';
        this.hideInfoBubble();
    },

    hideRulesBubble: function () {
        if (this.rulesBubble) this.rulesBubble.style.display = 'none';
    },

    createRulesBubble: function () {
        // this.rulesBubble = new HtmlDom(rulesBubbleTemplate, {}, this);
        // this.rulesBubble.style.display = 'none';
        // this.rulesBubble.style.zIndex = 999;
        // this.containers.rules = this.rulesBubble.querySelectorAll('[containers="rules"]')[0];
    },

    createInfoHandle: function () {
        // this.infoHandle = new HtmlDom(infoHandleTemplate, {}, this);
        // return this.infoHandle;
    },

    assignComplectItem: function (item, v) {
        if (v) {
            if (!item)
                item = {
                    id: 0,
                    count: 0,
                    sale: 0,
                    real_sale: 0,
                    name: '',
                    sum: 0,
                    img: '',
                    package: 0,
                    amountAct: 0,
                    priceRub: 0,
                    priceRubFull: 0,
                    rec_count: 0,
                    measure: '',
                    boxAction: false,
                    // restore:true,
                    dbg: {
                        cnt: 0,
                        real_sale: '',
                        sale: '',
                        count: '',
                        sum: '',
                    }
                };
            //console.log('ITEM',JSON.stringify(v));
            item.id = v.id;
            item.count += v.count;
            item.sale = Math.max(item.sale, v.sale);
            item.real_sale = Math.max(item.real_sale, v.real_sale);
            item.name = v.name;
            item.sum += v.sum;
            item.img = v.img;
            item.package = v.package;
            item.amountAct = v.amountAct;
            item.curPrice = v.curPrice;
            item.price = v.price;
            item.curRate = v.curRate;
            item.zaEdDeneg = v.zaEdDeneg;
            item.priceRub = v.priceRub;
            item.priceRubFull = v.priceRubFull;
            item.rec_count = v.rec_count;
            item.measure = v.measure;
            item.boxAction = v.boxAction;
            item.dbg.cnt++;
            item.dbg.real_sale += v.real_sale + ', ';
            item.dbg.sale += v.sale + ', ';
            item.dbg.count += v.count + ', ';
            item.dbg.sum += v.sum + ', ';
        }
        return item;
    },
    getOrderItems: function (cb) {
        let self = this;
        let items = {};
        for (let ck in this.complects) {
            if (Object.prototype.hasOwnProperty.call(this.complects, ck)) {
                let complect = this.complects[ck];
                if (complect && complect.inBusket) {
                    for (let gk in complect.groups) {
                        if (Object.prototype.hasOwnProperty.call(complect.groups, gk)) {
                            let gv = complect.groups[gk];
                            for (let k in gv.items) {
                                if (Object.prototype.hasOwnProperty.call(gv.items, k)) {
                                    let v = gv.items[k];
                                    if (v.count > 0) {
                                        items[v.id] = self.assignComplectItem(items[v.id], v);
                                    }
                                }
                            }
                        }
                    }
                    for (let k in complect.goods) {
                        if (Object.prototype.hasOwnProperty.call(complect.goods, k)) {
                            let v = complect.goods[k];
                            if (v.count > 0) {
                                if (complect.id == 0 || v.added) {
                                    items[v.id] = self.assignComplectItem(items[v.id], v);
                                }
                            }
                        }
                    }
                } // isset complect
            }
        }
        self.orderItems = {};
        self.order = [];
        for (let k in items) {
            if (Object.prototype.hasOwnProperty.call(items, k)) {
                let v = items[k];

                if (v.boxAction) {
                    v.real_sale += 3;
                }

                let item = new AI_helperItemClass(v, self, null, 'preview');

                self.order[self.order.length] = {
                    goodId: item.id,
                    amount: item.count,
                    discount: item.real_sale,
                    price: item.sale_sum
                };

                self.orderItems[k] = item;
            }
        }
        if (cb) cb({order: this.order, items: this.orderItems});
    },

    binComplectOrder: function () {
        let self = this;
        let data = {
            items: self.order
        };
        if (data.items.length > 0) {
            this.makePost('aiHelper', 'binComplectOrder', data, null, function (respond) {
                let data = respond.data;
                if (!data.descr) data.descr = '';
                if (data.descr !== '')
                    alert(data.descr);
                if (respond.status === 'OK')
                    self.destroy();
            });
        } else
            alert('Заказ не содержит ни одной позиции!');
    },

    prepareComplectOrder: function () {
        // if (self.user.uid == 3228) {self.binComplectOrder();} else
        {
            let er = '';
            if (this.payer === 0) er += 'Не выбран плательщик! \n';
            if (this.num.length <= 0) er += 'Не указан Номер Заказа! \n';
            if (er === '') {
                let data = {
                    id: 0,
                    num: this.num,
                    delivery: this.delivery,
                    payer: this.payer,
                    items: this.order
                };
                if (!this.debug) {
                    this.saveComplectOrder(data);
                } else {
                    console.log('SEND ORDER:', data);
                    alert('SAVE');
                }
            } else alert(er);
        }
    },

    saveComplectOrder: function (data) {
        let self = this;
        this.makePost('aiHelper', 'saveComplectOrder', data, null, function (respond) {
            if (respond.errors && respond.errors[0])
                alert(respond.errors && respond.errors[0].descr);
            if (respond.status === 'OK') {
                // let data = respond.data;
                alert('Заказ передан на рассмотрение менеджеру');

                window.localStorage.removeItem(self.storage_id);

                self.complects = [];
                self.ids = [];

                window.location.reload();
            }
        });
    },
    toCart: function () {
        for (let k in this.groups) {
            if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
                let v = this.groups[k];
                v.toCart();
            }
        }
        for (let k in this.goods) {
            if (Object.prototype.hasOwnProperty.call(this.goods, k)) {
                let v = this.goods[k];

                v.toCart();
            }
        }
    },
    initPreviewBubble: function () {
        if (this.containers.previewBubble) {
            // this.containers.previewBubble.innerHTML = previewHeaderTemplate;
            // let i = 0;
            // let sale_sum = 0;
            // let price_sum = 0;
            // for (let k in items) {
            //     if (Object.prototype.hasOwnProperty.call(items, k)) {
            //         let v = items[k];
            //         //console.log('ITEM', k , v);
            //         price_sum += v.sum;
            //         sale_sum += v.sale_sum;
            //         //if (v.real_sale<5) console.log(v.id, v.name, v.sale_sum, v.real_sale);
            //
            //
            //         v.appendPreview(this.containers.previewBubble);
            //         i++;
            //     }
            // }
            // // if (i <= 0) {
            // //     this.containers.previewBubble.innerHTML = '<tr><td colspan="5"><br /><br />ВЫ НЕ ДОБАВИЛИ НИ ОДНОГО КОМПЛЕКТА!<br /><br /><br /><br /></td></tr>';
            // // }
            // sale_sum = Math.round(sale_sum * 100) / 100;
            // price_sum = Math.round(price_sum * 100) / 100;
            // this.renderFields('sale_sum',sale_sum);
            // this.renderFields('sum',price_sum);
        }
    },

    createPreviewBubble: function () {
        // this.previewBubble = new HtmlDom(previewTemplate, {}, this);
        // this.previewBubble.style.display = 'none';
        // this.containers.previewBubble = this.previewBubble.querySelectorAll('[containers="preview"]')[0];
        // this.infoFields.preview = {};
        // this.infoFields.preview.total = this.previewBubble.querySelectorAll('[model="total"]')[0];
        // this.infoFields.preview.sum = this.previewBubble.querySelectorAll('[model="sum"]')[0];
        // this.infoFields.preview.sale_sum = this.previewBubble.querySelectorAll('[model="sale_sum"]')[0];
    },

    showPreviewBubble: function () {
        // let self = this;
        // this.getOrderItems(function (data) {
        //     self.initPreviewBubble(data.items);
        //     if (self.previewBubble) self.previewBubble.style.display = 'block';
        // });
    },

    hidePreviewBubble: function () {
        // if (this.previewBubble) this.previewBubble.style.display = 'none';
    },


    createProccessBubble: function () {
        // this.num = '';
        // this.delivery = 0;
        // this.payer = 0;
        // this.proccessBubble = new HtmlDom(proccessTemplate, {}, this);
        // this.proccessBubble.style.display = 'none';
        // this.containers.payer = this.proccessBubble.querySelectorAll('[containers="payer"]')[0];
        // this.containers.delivery = this.proccessBubble.querySelectorAll('[containers="delivery"]')[0];
        // this.containers.num = this.proccessBubble.querySelectorAll('[containers="num"]')[0];
        // this.initProccessBubble();
    },


    payerChange: function (e, o) {
        this.payer = o.value;
    },

    deliveryChange: function (e, o) {
        this.delivery = o.value;
    },

    numChange: function (e, o) {
        this.num = o.value;
    },

    showProccessBubble: function () {
        let er = '';
        let self = this;
        self.getOrderItems(function (data) {
            self.order = data.order;
            if (self.order.length <= 0) er += 'Заказ не содержит ни одной позиции! \n';
            if (self.fullsum <= 0) er += 'Вы не можете отправить пустой заказ! \n';
            if (!er) {
                if (self.proccessBubble) self.proccessBubble.style.display = 'block';
            } else
                alert(er);
        });
    },

    hideProccessBubble: function () {
        if (this.proccessBubble) this.proccessBubble.style.display = 'none';
    },

    inflatePayers: function () {
        if (this.containers.payer && this.payers) {
            for (let k in this.payers) {
                if (Object.prototype.hasOwnProperty.call(this.payers, k)) {
                    let v = this.payers[k];
                    if (!v.showName) v.showName = '';
                    let option = document.createElement('option');
                    option.value = k;
                    // option.innerHTML = v.showName;
                    // this.containers.payer.appendChild(option);
                }
            }
            this.containers.payer.value = '0';
        }
    },

    inflateDeliveries: function () {
        if (this.containers.delivery && this.deliveryTypes) {
            for (let k in this.deliveryTypes) {
                if (Object.prototype.hasOwnProperty.call(this.deliveryTypes, k)) {
                    // let v = this.deliveryTypes[k];
                    let option = document.createElement('option');
                    option.value = k;
                    // option.innerHTML = v;
                    // this.containers.delivery.appendChild(option);
                }
            }
            this.containers.delivery.value = '0';
        }
    },

    initProccessBubble: function () {
        let self = this;
        if (!self.payers) {
            self.makePost('aiHelper', 'payersList', {}, null, function (respond) {
                if (respond.status === 'OK') {
                    if (respond.data.payers) self.payers = respond.data.payers;
                    if (respond.data.deliveries) self.deliveries = respond.data.deliveries;
                    self.inflatePayers();
                    self.inflateDeliveries();
                }
            });
        } else {
            self.inflatePayers();
            self.inflateDeliveries();
        }
    },

    initRulesBubble: function (action) {
        if (!this.mainContainer) this.initMain();

        if (this.rulesBubble) {
            // let self = this;
            this.makePost('aiHelper', action, {}, null, function (respond) {
                if (respond.status === 'OK') {
                    // self.containers.rules.innerHTML = respond.data;
                }
            });
            this.showRulesBubble();
        }
        // this.hideInfoBubble();

    },

    showRules: function () {
        this.initRulesBubble('rules');
    },

    showSales: function () {
        this.initRulesBubble('sales');
    },

    showAbout: function () {
        this.initRulesBubble('about');
    },

    showCashBack: function () {
        this.initRulesBubble('cashback');
    },

    showPrivilege: function () {
        this.initRulesBubble('privilege');
    },


};
export default ai_helper;
//
// let params= {
//     //url: 'https://sale.katris.ru/proxy/auth/',
//     //key: 'W5pRNSx8Dx3tGY65xx3BOgAAAAE',
// };
//
// if (env ==='development') {
//     window.ai_helper.debug = true;
//     params.url='https://sale.katris.ru/proxy/AI_HELPER_45745673029734/';//debug ONLY
//     console.log(process.env.NODE_ENV);
//     window.ai_helper.init(params);
//
// }
// let page_name = unescape(window.location.href );
// page_name = page_name.substring( page_name.lastIndexOf('/') + 1, page_name.length );
// if (page_name === 'parts_aj.php')
//     window.ai_helper.init(params);


